import { combineReducers } from "redux";
import interviewReducer from "./interview.reducer";

const rootReducer = combineReducers({
  interview: interviewReducer,
});

export default rootReducer;
